module.exports = __webpack_public_path__ + "img/gzh_qrcode.1874c3da.jpg";